export default {"src":"/_next/static/media/lazo-circular-icon.f0743b89.svg","height":45,"width":45,"blurWidth":0,"blurHeight":0};